var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-filial-item",class:{
    selected: _vm.selected,
    's-select-value': _vm.isSelectValue,
    's-list-item': _vm.isListItem,
    's-use-callcenter': _vm.item.useCallCenter,
    's-is-not-connected': _vm.isNotConnected,
    's-is-connected': _vm.isConnected,
    's-is-disabled': _vm.isDisabled,
  }},[_c('div',{staticClass:"s-filial-item__icon"},[(_vm.isDisabled)?_c('icon-deactivated-filial'):(_vm.item.franchise)?_c('icon-franchise-filial'):_c('icon-own-filial')],1),_c('div',{staticClass:"s-filial-item__content"},[_c('div',{staticClass:"s-filial-item__address"},[_vm._v(" "+_vm._s(_vm.firstNameLine)+" ")]),(!_vm.item.isCallCenter)?_c('div',{staticClass:"s-filial-item__city"},[_vm._v(" "+_vm._s(_vm.lastNameLine)+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }